﻿$.fn.dxCtrlBcArticle = function custom_dxCtrlBcArticle(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbcarticle dx-ctrl");
        this.createInstance(new cdxCtrlBcArticle(this, option));
    }
    return this;
}

window.cdxCtrlBcArticle = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var jauge = null
    function mConstruit() {
        container.empty();
        container.css({
            "display": "none",
            "background-color": "white",
            "color": "black",
            "padding-top": "5px",
            "border-radius": "20px"
        })
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        //jauge.mShow()

        //gestCognoss.mGetAppliCourante()
        //gestCognoss.isAdmin()
        option.bddCtrl.mAjaxCall({
            command: "getdatabcarticle",
            id_bc_article: option.elementBc.id_bc_article,
            id_bc_appli: ((gestCognoss.isAdmin()) ? null : gestCognoss.mGetAppliCourante().bcAppli.id_bc_appli),
            nom_base_client: option.bddCtrl.nomBaseClientForCognoss
        }, function (data) {
            if (typeof data.lstfile == "undefined") data.lstfile = []
            //mRempli(data.html, data.lstfile, data.urlhtml)

            var $Table = $("<table style='width:calc(100% - 20px);margin:10px;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;padding-right:10px;vertical-align:top;'/>").appendTo($Tr)

            var dxCtrlImage = $("<div style='width:100%;height:100%;'/>").appendTo($Td).dxCtrlImageData({
                bddCtrl: option.bddCtrl,
                size: 60,
                data: option.elementBc,
                showTextOnImage: false,
                showText: false,
                fontSizeText: "30px",
                noDataText: "(aucune image)",
                allowClick: false
            }).dxCtrlImageData("instance");

            var $Td = $("<td style='width:100%;vertical-align:top;'/>").appendTo($Tr)

            $("<div style='padding:0px 0px;font-size:200%;font-weight:bold;font-variant:small-caps;letter-spacing:-1px;'>" + option.elementBc.objet.replace(/%%nom_appli%%/g, gestCognoss.mGetAppliCourante().nom) + "</div>").appendTo($Td)
            if (!option.readOnly) {
                var urlLink = option.bddCtrl.getObjet(option.elementBc).objetMetier.mGetLink(option.appli)
                var $SpanLink = $("<span class='state-hover' style='font-size:60%;opacity:1;'></span>").appendTo($Td)
                $SpanLink.attr("title", "Cliquer pour copier l'adresse dans le presse-papier")
                $SpanLink.html("<i class='fas fa-copy'></i><u style='padding-left:3px;'>" + urlLink + "</u>")
                $SpanLink.on("click", function (e) {
                    e.stopPropagation()
                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val(option.bddCtrl.getObjet(option.elementBc).objetMetier.mGetLink(option.appli)).select();
                    document.execCommand("copy");
                    $temp.remove();
                    mNotify("L'adresse de la page a été copiée dans le presse-papier", "success", 6000)
                })
                //} else {
                //    history.pushState({ foo: 'bar' }, parametre.nom, urlLink);
            }
            //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $SpanLink, position: "bottom", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'></div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");

            var $TableUti = $("<table/>").appendTo($Td)
            var $TrUti = $("<tr/>").appendTo($TableUti)
            var $TdUti = $("<td style='min-width:30px'/>").appendTo($TrUti)
            $("<div style='width:100%;height:30px;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgStrConUti({
                bddCtrl: option.bddCtrl,
                idTable: option.bddCtrl.getObjet("utilisateur").mGetTable().id_table,
                id: option.elementBc.id_utilisateur,
                text: option.bddCtrl.getObjet("utilisateur", option.elementBc.id_utilisateur).mGetLib1(),
                hideText: true
            })
            var $TdUti = $("<td style='width:100%;font-size:70%;opacity:0.6;padding-left:10px;'>Ecrit par " + option.bddCtrl.getObjet("utilisateur", option.elementBc.id_utilisateur).mGetLib1() + "<br/>Mise à jour il y a plus d'une semaine</td>").appendTo($TrUti)

            if (data.lstfile.length > 0) {
                $DivFichier = $("<div style='margin:10px 0;margin-bottom:10px;'/>").appendTo($Td)
                dxCtrlFichierJoint = $("<div/>").appendTo($DivFichier).dxCtrlFichier2Document({
                    bddCtrl: option.bddCtrl,
                    readOnly: true,
                    dataSource: data.lstfile
                }).dxCtrlFichier2Document("instance")
            }

            if (!option.readOnly) {
                var $Td = $("<td style='width:0px;vertical-align:top;' rowspan='2'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-pen",
                    txtTooltip: "Modifer",
                    onClick: function (e) {
                        option.bddCtrl.getObjet(option.elementBc).mShowPopup()
                    }
                })
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    txtTooltip: "Poubelle",
                    onClick: function (e) {
                        e.event.stopPropagation()
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: e.component.element(),
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "24px");
                                if (option.bddCtrl.getObjet(option.elementBc).mGetTable().nom == 'bc_dossier') {
                                    $("<div>Mettre le dossier<br/>et tous ses articles et ses dossiers<br/>à la corbeille.</div>").appendTo(contentElement)
                                } else {
                                    $("<div>Mettre l'article à la corbeille.</div>").appendTo(contentElement)
                                }
                                $("<div style='padding-top:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                    text: "Confirmer",
                                    width: "100%",
                                    onClick: function (e) {
                                        option.bddCtrl.getObjet(option.elementBc).mDelData(function () {
                                            option.onDelete(option.elementBc)
                                        })
                                        tt.hide()
                                    }
                                }).dxCtrlButton("instance")
                            }
                        }).dxCtrlTooltip("instance");
                        tt.show()
                    }
                })
            }
            var $Td = $("<td style='width:0px;vertical-align:top;' rowspan='2'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-print",
                txtTooltip: "Imprimer",
                onClick: function (e) {
                    jaugeDemarrage.mShow();
                    jaugeDemarrage.option("message", "Génération de l'impression")
                    option.bddCtrl.mAjaxCall({
                        command: "printemailenvoi",
                        id: option.bddCtrl.getObjet(option.elementBc).cle(),
                        nom_table: "bc_article",
                        externe: "1"
                    }, function (data) {
                        if (data.urlpdf.startsWith("~")) data.urlpdf = data.urlpdf.substring(1)
                        window.open(data.urlpdf, "_blank")
                        //$("<div/>").appendTo("body").dxCtrlViewer({
                        //    bddCtrl: option.bddCtrl,
                        //    value: [data.urlpdf],
                        //    indexCourant: 0
                        //})
                        jaugeDemarrage.mHide();
                        jaugeDemarrage.option("message", null)
                    })
                }
            })

            var $Div = $("<div style='border-bottom:" + theme.border + ";'/>").appendTo(container)
            var $DivDoc = $("<div style='margin:10px;'/>").appendTo(container)

            ////// Convertir la chaîne HTML en un objet jQuery
            ////var $parsedHtml = $($.parseHTML(data.html));
            ////// Extraire uniquement le contenu de `<body>`
            ////var bodyContent = $parsedHtml.find("body").html();
            //var bodyContent = $('<div>').html(data.html).find('body').html();
            //$DivDoc.append($("<div>" + bodyContent + "</div>"))
            var $iFrame = $("<iframe src='" + ((typeof data.urlhtml == 'undefined') ? "" : data.urlhtml) + "' style='width:100%;height:100%;box-sizing:border-box;border:none;background-color:white;min-height:" + ($(container.closest(".dx-ctrlpagebc")).innerHeight() - $Table.innerHeight()) + "px;' sandbox='allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation'>").appendTo($DivDoc)

            var isLoaded = false
            $iFrame.on("load", function () {
                // Récupérer le document interne de l'iframe
                const iframe = this;
                const doc = iframe.contentDocument || iframe.contentWindow.document;

                doc.addEventListener('click', function (e) {
                    debugger
                    const a = e.target.closest('a');
                    if (!a) return;

                    // STOP AVANT TOUT
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    const href = a.getAttribute('href') || '';

                    if (href.includes('/about:blank?id_article=')) {
                        const idArticle = href.split('/about:blank?id_article=')[1];
                        page.mDisplayArticleBc(idArticle);
                    } else {
                        window.open(href,"_blank")
                    }
                }, true); // 👈 CAPTURE PHASE (indispensable)
                //// Sélectionner tous les liens
                //iframeDoc.find('a').on('click', function (e) {

                //    let href = this.getAttribute('href');
                //    if (href.startsWith("about:blank?id_article=")) {
                //        e.preventDefault();
                //        var idArticle = href.replace("about:blank?id_article=", "")
                //        idArticle = idArticle.split("&")[0]
                //        page.mDisplayArticleBc(idArticle)
                //    } else if (href.startsWith("/about:blank?id_article=")) {
                //        e.preventDefault();
                //        var idArticle = href.replace("/about:blank?id_article=", "")
                //        idArticle = idArticle.split("&")[0]
                //        page.mDisplayArticleBc(idArticle)
                //    }
                //});
                if (isLoaded) {
                    //var currentUrl = $(this).prop("contentWindow").location.href;
                    //if (currentUrl.startsWith("about:blank?id_article=")) {
                    //    var idArticle = currentUrl.replace("about:blank?id_article=", "")
                    //    idArticle = idArticle.split("&")[0]
                    //    page.mDisplayArticleBc(idArticle)
                    //} else if (currentUrl.startsWith("/about:blank?id_article=")) {
                    //    var idArticle = currentUrl.replace("/about:blank?id_article=", "")
                    //    idArticle = idArticle.split("&")[0]
                    //    page.mDisplayArticleBc(idArticle)
                    //}
                } else {
                    mResizeIframe()
                    function mResizeIframe() {
                        if (typeof $iFrame.contents == 'undefined') {
                            window.setTimeout(function () { mResizeIframe() }, 200)
                        } else {
                            isLoaded = true
                            $iFrame.css("height", ($iFrame.contents().find("body").innerHeight() + 50) + 'px')

                            var doc = $iFrame[0].contentDocument || $iFrame[0].contentWindow.document;
                            var innerHtml = doc.body.innerHTML
                            innerHtml = innerHtml.replace(/%%nom_appli%%/g, gestCognoss.mGetAppliCourante().nom);
                            innerHtml = innerHtml.replace(/%%site_vitrine_appli%%/g, gestCognoss.mGetAppliCourante().urlvitrine);
                            innerHtml = innerHtml.replace(/%%site_app_appli%%/g, gestCognoss.mGetAppliCourante().urlapp);
                            innerHtml = innerHtml.replace(/%%site_conf_appli%%/g, gestCognoss.mGetAppliCourante().urlconf);
                            innerHtml = innerHtml.replace(/%%site_conf_appli_sans_http%%/g, gestCognoss.mGetAppliCourante().urlconf.replace("https://", ""));
                            innerHtml = innerHtml.replace(/%%code_appli%%/g, gestCognoss.mGetAppliCourante().code_appli_general);
                            //innerHtml = innerHtml.replace(/%%site_appli_contact%%/g, gestCognoss.mGetAppliCourante().urlvitrine + "#contact");
                            doc.body.innerHTML = innerHtml

                            // Remplacement dans les liens href
                            doc.querySelectorAll("a").forEach(function (link) {
                                if (!gestCognoss.isAdmin()) {
                                    link.href = link.href.replace(/%%site_vitrine_appli%%/g, gestCognoss.mGetAppliCourante().urlvitrine);
                                    link.href = link.href.replace(/%%site_app_appli%%/g, gestCognoss.mGetAppliCourante().urlvitrine);
                                    //$(this).attr("href", gestCognoss.mGetAppliCourante().urlvitrine + "#contact")
                                } else {
                                    link.href = link.href.replace(/%%site_vitrine_appli%%/g, "https://w3.ppmascaron.eu#contact");
                                    link.href = link.href.replace(/%%site_app_appli%%/g, "https://app.ppmascaron.eu");
                                    //link.href = link.href.replace(/%%site_appli%%/g, "MaValeur");
                                    //    $(this).attr("href", "https://w3.ppmascaron.eu" + "#contact")
                                }
                            });
                            //$($iFrame[0].contentDocument).find("a[href='%%sitevitrinepopsoftcontact%%']").each(function () {
                            //    if (!gestCognoss.isAdmin()) {
                            //        $(this).attr("href",gestCognoss.mGetAppliCourante().urlvitrine + "#contact")
                            //    } else {
                            //        $(this).attr("href", "https://w3.ppmascaron.eu" + "#contact")
                            //    }
                            //})
                        }
                    }
                }
            })

            container.fadeIn(500)
            //jauge.mHide()
        })

    }

    this.element = function () { return container; }

    mConstruit();
}